import React from 'react';
import HeroSlider from '../components/HeroSlider';
import WelcomeSection from '../components/WelcomeSection';
import CampusExcellence from '../components/CampusExcellence';
import LifeAtSchool from '../components/LifeAtSchool';
import OfferingsSection from '../components/OfferingsSection';
import './Home.css';

const Home = () => {
  return (
    <main className="home-page">
      <HeroSlider />
      <WelcomeSection />
      <OfferingsSection />
      <CampusExcellence />
      <LifeAtSchool />
    </main>
  );
};

export default Home;

